import { isDisabled } from "@testing-library/user-event/dist/utils";
import React, { useEffect, useRef, useState } from "react";

const PlacesAutocomplete = ({ apiKey, onSelect, defaultValue ,disabled}) => {
  const [inputValue, setInputValue] = useState(defaultValue || ""); // Inicializa con defaultValue si está disponible
  const autocompleteRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      const autocomplete = new window.google.maps.places.Autocomplete(
        autocompleteRef.current,
        { types: ["address"] }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.geometry) {
          // Actualiza el valor del campo de entrada con la dirección seleccionada
          setInputValue(place.formatted_address);

          // Llama a la función onSelect con los datos seleccionados
          onSelect({
            address: place.formatted_address,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          });
        }
      });
    };

    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [apiKey, onSelect]);

  // Actualiza el valor inicial si `defaultValue` cambia
  useEffect(() => {
    setInputValue(defaultValue || "");
  }, [defaultValue]);

  return (
    <input
      ref={autocompleteRef}
      type="text"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder="Av. Reforma 123, Colonia Juárez, Alcaldía Cuauhtémoc, Ciudad de México, C.P. 06600"
      className={`w-full pl-10 pr-3 py-3 border-[1px] rounded-[6px] placeholder:text-black focus:outline-none focus:ring focus:ring-grey  ${isDisabled} ? "bg-[#f3f4f6]" : 'white'`}
      disabled={disabled}
    />
  );
};

export default PlacesAutocomplete;
